'use client';

/**
 * Web launcher + URL cleanup for the SIGNED-OUT waitlist X join flow
 * (signup v2). Sibling of `use-x-connect.ts`, but redirect-only — the
 * early-access gate is a full page, so there is no popup/postMessage
 * branch and no hook state to manage.
 *
 * Lives under `src/platform/web/` because it drives `window.location` and
 * `window.history` — web-only APIs.
 */

import { buildXWaitlistStartUrl } from '../../../../auth/oauth/x-waitlist-result.js';

/**
 * Navigate the page to the backend waitlist X start URL (full-page
 * redirect; the browser comes back to /early-access with `?waitlist_x=*`).
 */
export function startXWaitlistJoin(
  apiBaseUrl: string,
  args: { ref?: string | null; locale?: string },
): void {
  if (typeof window === 'undefined') return;
  window.location.href = buildXWaitlistStartUrl(apiBaseUrl, args); // ALLOW-NETWORK-UNAWARE: external X OAuth start URL — leaves morfi.markets entirely
}

/**
 * Strip the waitlist X result params from the current URL via
 * `history.replaceState` so refreshes don't replay the result card and the
 * signed xToken doesn't linger in the address bar / history.
 */
export function stripXWaitlistQueryParams(): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  let touched = false;
  for (const param of ['waitlist_x', 'handle', 'xt']) {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      touched = true;
    }
  }
  if (touched) {
    window.history.replaceState({}, '', url.toString()); // ALLOW-NETWORK-UNAWARE: query-string cleanup, preserves the current pathname (no navigation)
  }
}
